import { nanoid } from 'nanoid';
import { defineStore } from 'pinia';

const rawParticipant = {
  id: '',
  salutation: '',
  title: '',
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  myfischer: false,
  isValid: false,
};

export const useSeminarRegistrationStore = defineStore('seminar-registration', {
  state: () => ({
    totalParticipants: 1,
    company: '',
    address: {
      street: '',
      streetNumber: '',
      zipcode: '',
      city: '',
      country: '',
    },
    formValid: false,
    participants: [{ ...rawParticipant }],
  }),
  actions: {
    addParticipant() {
      this.totalParticipants += 1;
      this.participants.push({ ...rawParticipant, id: nanoid() });
    },
    removeParticipant(index: number) {
      this.totalParticipants -= 1;
      this.participants.splice(index, 1);
    },
    reset() {
      this.totalParticipants = 1;
      this.company = '';
      this.formValid = false;
      this.participants = [this.participants[0]];
    },
  },
  getters: {
    isFormValid(state) {
      if (!state.formValid || state.participants.some((el) => el.isValid === false)) {
        return false;
      }

      return true;
    },
  },
});
